import React, { Fragment, useState, useEffect } from 'react';
import { Col, Container, Row, Card, CardBody } from 'reactstrap';
import Spinner from 'react-bootstrap/Spinner';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import moment from 'moment';
import LocalHospitalIcon from '@material-ui/icons/LocalHospital';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import ListAltIcon from '@material-ui/icons/ListAlt';
import CloseIcon from '@material-ui/icons/Close';
import { calculateAgeParse } from '../../../../Utils/Patient';
import pdfEvent from '../../../../ClinicHistory/ClinicEvent/components/PdfReports/PdfEvent';
import { Modal } from '@material-ui/core';


const PatientDiagnosis = ({ id_historia, clinicHistoryByPatient, patient }) => {
    const [patiensDiagnosis, setPatiensDiagnosis] = useState(null);
    const [load, setLoad] = useState(false);
    const [expanded, setExpanded] = useState(false);
    const [eventByAdmission, setEventByAdmission] = useState(null);
    const [showPDFClinicEvent, setShowPDFClinicEvent] = useState(false);
    const urlLogo = sessionStorage.getItem('logoURL');
    const profile = JSON.parse(sessionStorage.getItem('clinica'));

    useEffect(() => {
        const loadPatientDiagnosis = async () => {
            setLoad(true);
            await fetch(process.env.REACT_APP_PUBLIC_URL + 'diagnostico/consulta-por-paciente?id_historia=' + id_historia, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                },
            })
                .then(response => {
                    return response.json();
                })
                .then(data => {
                    console.log(data);
                    if (data.diagnostico.length > 0) {
                        setPatiensDiagnosis(data.diagnostico);
                        setLoad(false);
                        //setOpen(data.diagnostico.id_diagnostico);
                    } else {
                        setPatiensDiagnosis(null);
                        setLoad(false);
                    }
                })
                .catch((error) => {
                    console.error('Error:', error);
                });
        }
        loadPatientDiagnosis();
    }, [])

    const getPrintEvent = (id_historia, id_admision) => {
        return new Promise((resolve, reject) => {
            const dataSend = {
                id_historia: parseInt(id_historia),
                id_admision: parseInt(id_admision)
            }
            fetch(process.env.REACT_APP_PUBLIC_URL + 'evento/consultar', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                },
                body: JSON.stringify(dataSend)
            })
                .then(response => {
                    return response.json();
                })
                .then(data => {
                    console.log("evento/consultar", data);
                    //setEventByAdmission(data.contenido);
                    resolve(data.contenido);
                })
                .catch((error) => {
                    alert(error);
                    resolve([]);
                    console.error('Error:', error);
                });
        })
    }

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    const searchEventFromClinicHistoryComplete = (id_admision) => {
        let eventClinic = null;
        if (clinicHistoryByPatient !== null && clinicHistoryByPatient !== undefined) {
            eventClinic = clinicHistoryByPatient.filter((eventClinic) => eventClinic.id_admision === id_admision)
        }
        setEventByAdmission(eventClinic[0]);
    }

    const getListRadipharmacyDosse = (id_admision) => {
        return new Promise((resolve, reject) => {
            fetch(process.env.REACT_APP_PUBLIC_URL + 'admision-radiofarmaco/listar-por-admision?id_admision=' + id_admision, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                }
            }).then(response => {
                if (response.status != 500 && response.status != 403) {
                    return response.json();
                }
                else {
                    throw new Error("Ha ocurrido un error en el servidor");
                }
            }).then(data => {
                if (data.length > 0) {
                    resolve(data);
                }
                else {
                    resolve([]);
                }
            }).catch((error) => {
                resolve([]);
                console.error('Error:', error);
            });
        })
    }

    const generateClinicEvent = async (historyEvent) => {
        console.log("DESActions", historyEvent);
        let clinicEvent = await getPrintEvent(patient?.id_historia, historyEvent.id_admision);
        console.log("DES", clinicEvent);
        let farmacos = await getListRadipharmacyDosse(historyEvent.id_admision);
        var fullname = patient?.nombres + ' ' + patient?.apellido1 + ' ' + patient?.apellido2;
        //infoAdmission.admision?.id_admision
        let infoAdmission = { admision: { id_admision: historyEvent.id_admision, fecha: historyEvent.fecha } }
        let nameProcedure = historyEvent.cita?.servicio?.servicios.length > 0 ? historyEvent.cita?.servicio?.servicios[0].nombre : '';
        let cupsProcedure = historyEvent.cita?.servicio?.servicios.length > 0 ? historyEvent.cita?.servicio?.servicios[0].codigo : '';

        /* if(historyEvent.transcripcion === null && historyEvent.anamnesis !== null && historyEvent.anamnesis !== undefined){
        } else if (historyEvent.transcripcion !== null){
            printTranscription(historyEvent.transcripcion );
        } */
        const data = {
            today: new Date(),
            urlLogo: urlLogo,
            names: fullname,
            day: new Date(),
            ordenes: clinicEvent?.ordenes,
            anamnesis: clinicEvent?.anamnesis,
            antecedentes: clinicEvent?.antecedentes,
            fisico: clinicEvent?.fisico,
            plan: clinicEvent?.plan,
            gender: patient?.sexo,
            address: patient?.direccion.direccion,
            city: patient?.direccion.ciudad,
            telephone: patient?.telefono1,
            cellphone: patient?.celular,
            civilStatus: patient?.e_civil,
            bloodType: patient?.tipo_sangre,
            typeOfDocument: patient?.tip_documento,
            documentNumber: patient?.num_documento,
            profile: profile,
            age: calculateAgeParse(patient?.fec_nacimiento),
            birthday: patient?.fec_nacimiento,
            professional: clinicEvent?.profesional,
            id_profesional: historyEvent?.id_profesional,
            speechTerapy: clinicEvent?.speechTerapy,
            radioPharmacy: clinicEvent?.radioPharmacy,
            medicalRegister: clinicEvent?.registro_clinico,
            diagnostico: clinicEvent?.diagnostico,
            notas_clinicas: clinicEvent?.notas_clinicas,
            radioPharmacyList: farmacos,
            sistemas: clinicEvent?.sistemas,
            //third: third,
            infoAdmission: infoAdmission,
            transcripcion: historyEvent?.transcripcion,
            nameProcedure: nameProcedure,
            cupsProcedure: cupsProcedure,
            otherProcedures: clinicEvent?.procedimientos,
            cita: historyEvent?.cita
        };
        setShowPDFClinicEvent(true);
        await pdfEvent(data);

    }

    return (
        <Fragment>
            <Col md={12} lg={12} xl={12} xs={12}>
                <Card>
                    <CardBody style={{ padding: 0 }}>
                        <Row>
                            <div className='clinic-history-info'>
                                <div>
                                    <h4><b>DIAGNÓSTICOS</b></h4>
                                </div>
                                <div>
                                    <h5>Historia Clínica No. <b>{id_historia}</b></h5>
                                </div>
                            </div>
                        </Row>
                        <Row>
                            <Col>
                                {load ?
                                    <div className="text-center">
                                        <Spinner animation="border" style={{ color: '#4ce1b6', marginTop: '2em' }} />
                                    </div>
                                    :
                                    patiensDiagnosis &&
                                    patiensDiagnosis.length &&
                                    patiensDiagnosis.map((diagnosis) => (
                                        <Accordion key={diagnosis.id_diagnostico} expanded={expanded === `panel${diagnosis.id_diagnostico}`} onChange={handleChange(`panel${diagnosis.id_diagnostico}`)}>
                                            <AccordionSummary
                                                expandIcon={<ExpandMoreIcon />}
                                                onClick={() => searchEventFromClinicHistoryComplete(diagnosis.id_admision)}
                                                aria-controls={`panel${diagnosis.id_diagnostico}-content`}
                                                id={`panel${diagnosis.id_diagnostico}-header`}
                                            >
                                                <div className='title-accordion-diagnosis'>
                                                    <LocalHospitalIcon style={{ color: '#55e5bb', marginRight: '0.25em' }} />
                                                    <h5>ADMISIÓN No. <b>{diagnosis.id_admision}</b></h5>
                                                </div>
                                            </AccordionSummary>
                                            <AccordionDetails>
                                                <div className='info-event-admission'>
                                                    {
                                                        eventByAdmission &&
                                                        <div className='info-event-admission-row'>
                                                            <div className='event-clinic-tooltip'>
                                                                <div>
                                                                    <h5>Resumén del Evento Clínico</h5>
                                                                </div>
                                                                <div>
                                                                    <Tooltip title="Ver evento clínico">
                                                                        <IconButton aria-label="launch" color="inherit" style={{ backgroundColor: '#55e5bb', width: '1.5em', height: '1.5em' }}
                                                                            disabled={patient !== null && patient !== undefined && clinicHistoryByPatient !== null && clinicHistoryByPatient !== undefined ? false : true}
                                                                            onClick={() => {
                                                                                generateClinicEvent(eventByAdmission);
                                                                            }}
                                                                        >
                                                                            <ListAltIcon style={{ color: '#153365', width: '1em', height: '1em' }} />
                                                                        </IconButton>
                                                                    </Tooltip>
                                                                </div>
                                                            </div>
                                                            <div className='info-event-admission-row-top'>
                                                                <div>
                                                                    <p><b>Servicio:</b> {eventByAdmission.cita?.servicio?.servicios[0].nombre} </p></div>
                                                                <div><p><b>Dr.(a):</b>{eventByAdmission.nombres + ' ' + eventByAdmission.apellido1 + ' ' + eventByAdmission.apellido2} </p></div>
                                                                <div><p><b>Fecha:</b> {moment(eventByAdmission.fecha).format('DD-MM-YYYY')} </p></div>
                                                            </div>
                                                        </div>

                                                    }

                                                    {diagnosis.diagnostico.diagnostico.map((diagInfo) => (
                                                        <div key={diagInfo.id} className='diagnosis-card-patient-info'>
                                                            <div className='diagnosis-card-patient-info-top-title'>
                                                                <div>
                                                                    <h4>CÓDIGO: <b>{diagInfo.codigo}</b></h4>
                                                                </div>
                                                                <div>
                                                                    <hr />
                                                                </div>
                                                                <div>
                                                                    <p>{diagInfo.nombre}</p>
                                                                </div>
                                                            </div>
                                                            {
                                                                diagnosis.observaciones &&
                                                                <div>
                                                                    <h5><b>Observación</b></h5>
                                                                    <p>{diagnosis.observaciones}</p>
                                                                </div>
                                                            }
                                                        </div>
                                                    ))}
                                                </div>
                                            </AccordionDetails>
                                        </Accordion>
                                    ))
                                }
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
            </Col>
            {showPDFClinicEvent ?
                <Modal
                    open={showPDFClinicEvent}
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    style={{ zIndex: 1000 }}
                >
                    <div className="paperAppointment-flex" style={{ width: '90%', margin: 10 }}>
                        <IconButton style={{ float: 'right' }} onClick={() => {
                            setShowPDFClinicEvent(false);
                        }}>
                            <CloseIcon />
                        </IconButton>
                        <div className='container-pdfs-modal'>
                            <iframe className='iframe-pdfs' id="pdfV" >
                            </iframe>
                        </div>
                    </div>
                </Modal>
                : null}
        </Fragment>
    )
}

export default PatientDiagnosis